import React, {useContext} from "react";
import {RankingsAndLevelsContext} from "../../../contexts/RankingsAndLevelsContext";
import Separator from "./Separator";
import Colors from "../../../assets/colors/Colors";
import {useTranslation} from "react-i18next";

const LifeNavabar: React.FC = () => {
    // @ts-ignore
    const { isLife, setIsLife } = useContext(RankingsAndLevelsContext);

    const shouldFocusOnLife = (focusOnLife: boolean) => {
        return (focusOnLife === isLife) ? 22 : 16;
    };

    const toggleLife = () => {
        setIsLife(!isLife);
    };
    const { t } = useTranslation();
    return (
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', padding: '5px 5px 5px 10px', color: isLife ? Colors.fontWhite : Colors.fontGray, marginRight: 20}}>
            <div style={{ margin: 'auto 0', fontSize: shouldFocusOnLife(true)}} onClick={toggleLife}> {t('lifeSelector.life')} </div>
            <Separator customStyle={{marginRight: 20, marginLeft: 20}} separatorColor={ isLife ? Colors.fontWhite : Colors.fontGray }/>
            <div style={{margin: 'auto 0', fontSize: shouldFocusOnLife(false)}} onClick={toggleLife}> {t('lifeSelector.noLife')} </div>
        </div>
    )
};

export default LifeNavabar;
